import React from "react";
import { InjectedFormikProps } from "formik";
import Input from "../../../../components/form/Input";
import { Row } from "reactstrap";

export interface ILoginFormElementsValues {
	username: string;
	password: string;
}

interface ILoginFormElementsProps {
	onGoogleLogin?: () => void;
	isSocialLoading?: boolean;
}

const LoginFormElements: React.FC<
	InjectedFormikProps<ILoginFormElementsProps, ILoginFormElementsValues>
> = (props) => {
	const {
		values: { username, password },
		handleChange,
		touched,
		handleBlur,
		errors,
		onGoogleLogin,
		isSocialLoading
	} = props;

	return (
		<div className="login-form-content">
{/* <div className="social-login-container">
				<button 
					type="button" 
					className="social-btn" 
					onClick={onGoogleLogin}
					disabled={isSocialLoading}
				>
					<img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" />
					{isSocialLoading ? "Signing in..." : "Continue with Google"}
				</button>
			</div>

			<div className="divider">or</div> */}

			<Row>
				<Input
					name="username"
					placeholder="Email address"
					value={username}
					handleChange={handleChange}
					errors={errors}
					touched={touched}
					handleOnBlur={handleBlur}
				/>
			</Row>
			<Row>
				<Input
					type="password"
					name="password"
					placeholder="Password"
					value={password}
					handleChange={handleChange}
					errors={errors}
					handleOnBlur={handleBlur}
					touched={touched}
				/>
			</Row>
		</div>
	);
};

export default LoginFormElements;
